export default "__VITE_ASSET__BtUvI1Nu__"